import { object, string } from 'yup';

export const getValidationSchema = (i18n) =>
    object().shape({
        username: string().required(i18n.t('common.fieldRequiredMessage')),
        password: string().required(i18n.t('common.fieldRequiredMessage')),
    });